import store_dhis2 from "@/store/mods/consultations/dhis-diagnostics"

export default {
    name: 'param-dhis-2',
    components: {
        
    },
    props: {
        can_autre_maladie: {
            type: Boolean,
            default: () => (true)
        }
    },
    data() {
        return {
            current_date_filter: {},
            curr_month: "",          // Current month of the year
            is_loading: true,
            is_empty: false,
            statistique_dhis2: {}
        }
    },

    watch: {
        curr_month() {
            const data = {
                month: this.curr_month.id,
            }
            this.current_date_filter = data
            this.getStatDHIS2()
        },
    },
    
    computed: {

    },

    mounted() {
        this.curr_month = this.monthOfYear[this.current_date.getMonth()+1]
    },

    methods: {
        getStatDHIS2() {
            this.is_loading = true
            store_dhis2.getStatConsultationDHIS2(this.current_date_filter).then((response) => {
                this.statistique_dhis2 = response

                this.is_loading = false
            })
        }
    }
}